import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { useContext } from "react";
import { Box } from "../Box/Box.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { TableContext, TableBodyContext } from "./TableContext.mjs";
import { tableSection } from "./Table.css.mjs";
const TableBody = ({ children, data, ...restProps }) => {
  const tableContext = useContext(TableContext);
  assert(tableContext, "TableBody must be used within a Table component");
  return /* @__PURE__ */ jsx(TableBodyContext.Provider, { value: true, children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "tbody",
      className: tableSection,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children
    }
  ) });
};
export {
  TableBody
};
